// Shared predicate for "is this directory entry a gallery-style
// piece of media?" Used by:
// - GridView, to decide whether to render PhotoTile vs FileTile.
// - ListView's Row, to dispatch tap handlers to onTapPhoto vs onTapFile.
// - GalleryViewer (Phase 2), to filter folder siblings to the swipe-able set.
//
// Keeping a single source of truth here prevents the views from
// drifting — e.g., adding audio/* later should happen in one place.

import type { DirEntry } from "@/worker/api";

export function isMediaEntry(entry: DirEntry): boolean {
  if (entry.kind !== "file") return false;
  const mime = entry.mime;
  if (!mime) return false;
  return mime.startsWith("image/") || mime.startsWith("video/");
}
